import {
  FETCH_CATALOG_PRODUCTS_LIST_SUCCESS,
  FETCH_CATALOG_PRODUCTS_LIST_ERROR,
  CLEAR_FETCH_CATALOG_PRODUCTS_LIST,
  APPLY_PRODUCT_DRAG_SUCCESS,
  APPLY_PRODUCT_DRAG_ERROR,
  CLEAR_PRODUCT_DRAG,
  ADD_PRODUCT_LINK_SUCCESS,
  ADD_PRODUCT_LINK_ERROR,
  CLEAR_ADD_PRODUCT_LINK,
  DELETE_PRODUCT_LINK_SUCCESS,
  DELETE_PRODUCT_LINK_ERROR,
  CLEAR_DELETE_PRODUCT_LINK,
  PATCH_PRODUCT_LINK_SUCCESS,
  PATCH_PRODUCT_LINK_ERROR,
  CLEAR_PATCH_PRODUCT_LINK,
  FETCH_CATALOG_DESCRIPTION_SUCCESS,
  FETCH_CATALOG_DESCRIPTION_ERROR,
  CLEAR_FETCH_CATALOG_DESCRIPTION,
  PATCH_CATALOG_DESCRIPTION_SUCCESS,
  PATCH_CATALOG_DESCRIPTION_ERROR,
  CLEAR_PATCH_CATALOG_DESCRIPTION,
} from 'redux/catalog/types';

const initialState = {
  catalogProductsList: null,
  catalogProductsListError: null,
  productsDragSuccess: null,
  productsDragError: null,
  addProductLinkSuccess: null,
  addProductLinkError: null,
  deleteProductLinkSuccess: null,
  deleteProductLinkError: null,
  patchProductLinkSuccess: null,
  patchProductLinkError: null,
  catalogDescription: null,
  catalogDescriptionError: null,
  patchCatalogDescriptionSuccess: null,
  patchCatalogDescriptionError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        catalogProductsList: action.payload.data,
        catalogProductsListError: null,
      };
    case FETCH_CATALOG_PRODUCTS_LIST_ERROR:
      return {
        ...state,
        catalogProductsList: null,
        catalogProductsListError: action.payload.data,
      };
    case CLEAR_FETCH_CATALOG_PRODUCTS_LIST:
      return {
        ...state,
        catalogProductsList: null,
        catalogProductsListError: null,
      };
    case APPLY_PRODUCT_DRAG_SUCCESS:
      return {
        ...state,
        productsDragSuccess: true,
        productsDragError: null,
      };
    case APPLY_PRODUCT_DRAG_ERROR:
      return {
        ...state,
        productsDragSuccess: null,
        productsDragError: action.payload.data,
      };
    case CLEAR_PRODUCT_DRAG:
      return {
        ...state,
        productsDragSuccess: null,
        productsDragError: null,
      };
    case ADD_PRODUCT_LINK_SUCCESS:
      return {
        ...state,
        addProductLinkSuccess: true,
        addProductLinkError: null,
      };
    case ADD_PRODUCT_LINK_ERROR:
      return {
        ...state,
        addProductLinkSuccess: null,
        addProductLinkError: action.payload.data,
      };
    case CLEAR_ADD_PRODUCT_LINK:
      return {
        ...state,
        addProductLinkSuccess: null,
        addProductLinkError: null,
      };
    case DELETE_PRODUCT_LINK_SUCCESS:
      return {
        ...state,
        deleteProductLinkSuccess: true,
        deleteProductLinkError: null,
      };
    case DELETE_PRODUCT_LINK_ERROR:
      return {
        ...state,
        deleteProductLinkSuccess: null,
        deleteProductLinkError: action.payload.data,
      };
    case CLEAR_DELETE_PRODUCT_LINK:
      return {
        ...state,
        deleteProductLinkSuccess: null,
        deleteProductLinkError: null,
      };
    case PATCH_PRODUCT_LINK_SUCCESS:
      return {
        ...state,
        patchProductLinkSuccess: action.payload.data,
        patchProductLinkError: null,
      };
    case PATCH_PRODUCT_LINK_ERROR:
      return {
        ...state,
        patchProductLinkSuccess: null,
        patchProductLinkError: action.payload.data,
      };
    case CLEAR_PATCH_PRODUCT_LINK:
      return {
        ...state,
        patchProductLinkSuccess: null,
        patchProductLinkError: null,
      };
    case FETCH_CATALOG_DESCRIPTION_SUCCESS:
      return {
        ...state,
        catalogDescription: action.payload.data,
        catalogDescriptionError: null,
      };
    case FETCH_CATALOG_DESCRIPTION_ERROR:
      return {
        ...state,
        catalogDescription: null,
        catalogDescriptionError: action.payload.data,
      };
    case CLEAR_FETCH_CATALOG_DESCRIPTION:
      return {
        ...state,
        catalogDescription: null,
        catalogDescriptionError: null,
      };
    case PATCH_CATALOG_DESCRIPTION_SUCCESS:
      return {
        ...state,
        patchCatalogDescriptionSuccess: action.payload.data,
        patchCatalogDescriptionError: null,
      };
    case PATCH_CATALOG_DESCRIPTION_ERROR:
      return {
        ...state,
        patchCatalogDescriptionSuccess: null,
        patchCatalogDescriptionError: action.payload.data,
      };
    case CLEAR_PATCH_CATALOG_DESCRIPTION:
      return {
        ...state,
        patchCatalogDescriptionSuccess: null,
        patchCatalogDescriptionError: null,
      };
    default:
      return state;
  }
};
